import client from '@/api/base';

export default {
  async getCategoryPricing() {
    const response = await client.get('coaching/coaches/pricing/');
    return response;
  },
};
